var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown2 = function SvgArrowDown2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    "data-name": "Move Down",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0Z",
    "data-name": "Path 12057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#892461",
    d: "M12.858 4.638v12.554l4.016-3.912a.978.978 0 1 1 1.3 1.4l-5.581 5.5a.973.973 0 0 1-1.447-.1l-5.62-5.425a.978.978 0 0 1 1.3-1.408l4.016 3.912v-12.5a.984.984 0 1 1 1.956-.026Z"
  })));
};
export default SvgArrowDown2;